module.exports = {"id":"183916","name":"Jérémy Pied","rating":"73","photo":"./data/images/photos/1/183916.png","club":{"name":"Southampton","logo":"./data/images/clubs/Southampton.png"},"positions":["DD","MD","DG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JeremyPied0.json
// module id = 1988
// module chunks = 0